import styles from "components/common/LinkPill.module.scss";
import externalLink from "images/externalLink.svg";

interface Props {
  url?: string;
  label: string;
  formattedValue?: string;
}

export const LinkPill = ({ url, label, formattedValue }: Props) => (
  <a href={url} rel="noopener noreferrer" target="_blank">
    <div className={styles.linkPill}>
      <div className={styles.linkPill__label}>{label}</div>
      {formattedValue ? (
        <div className={styles.linkPill__value}>{formattedValue}</div>
      ) : null}
      <div className={styles.linkPill__icon}>
        <img alt="External Link" src={externalLink} />
      </div>
    </div>
  </a>
);

export default LinkPill;
